module.exports = __webpack_public_path__ + "static/media/case-details-pl.34b62c3e.png";